export const rhodeislandCountiesList = [
    'Bristol',
    'Kent',
    'Newport',
    'Providence',
    'Washington',
    ]